import QRCode from "qrcode";
import React, { useEffect, useState } from "react";
interface IQRCodeProps{
  value: string;
}
export function QRCodeComponent(props: IQRCodeProps) {
  const {value} = props;
  const [dataUrl,setDataUrl] = useState<string>("");
  const generateQR = async () => {
    try {
      setDataUrl(await QRCode.toDataURL(value,{ errorCorrectionLevel: "H"}));
    } catch (err) {
      console.error(err)
    }
  }
  useEffect(() => {
    generateQR();
  },[value])
   
  return (<div className="text-center" >
    <img src={dataUrl} alt={dataUrl} />
  </div>);
}
